// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"af205ec6","578":"e9560711"}[chunkId] + ".chunk.js";
};